import React, {useState, useEffect} from 'react';
import cx from 'classnames';
import moment from 'moment-timezone';

import Button, {ButtonTypes} from '../../components/ButtonNew';
import {useAppContext} from '../../hooks';
import {publishQuestion, deleteQuestion} from '../../api/api';
import {PermissionType} from '../../../../lib/constants/permissions';

const Status = {
  PENDING: 'pending',
  PUBLISHED: 'published',
  ARCHIVED: 'archived',
};

const getInitialStatus = (question) => {
  if (question.removed_by) return Status.ARCHIVED;
  if (question.published_by) return Status.PUBLISHED;
  return Status.PENDING;
};

const AdminControls = ({question, className}) => {
  const [questionStatus, setQuestionStatus] = useState();
  const [loading, setLoading] = useState(false);
  const [hasUpdated, setHasUpdated] = useState(false);
  const {hasPermission} = useAppContext();
  const canPublish = hasPermission(PermissionType.QUESTION_PUBLISH);
  const canArchive = hasPermission(PermissionType.QUESTION_ARCHIVE);

  useEffect(() => {
    if (question) setQuestionStatus(getInitialStatus(question));
  }, [question?.id]);

  const handlePublish = async (e) => {
    e.stopPropagation();
    setLoading(true);
    await publishQuestion(question.id);
    setLoading(false);
    setHasUpdated(true);
    setQuestionStatus('published');
  };

  const handleArchive = async (e) => {
    e.stopPropagation();
    setLoading(true);
    await deleteQuestion(question.id);
    setLoading(false);
    setHasUpdated(true);
    setQuestionStatus('archived');
  };

  if (!question || !(canPublish || canArchive)) return null;

  return (
    <div className={cx('bg-indigo-100 py-2 px-4 text-sm font-normal flex items-center justify-between', className)}>
      <div className="flex items-center">
        <span className="font-bold text-indigo uppercase mr-1">
          {questionStatus}
        </span>
        {!hasUpdated && (
          <span className="text-xs font-medium text-gray-600">
            {questionStatus === Status.PENDING
            && `Submitted ${moment(question.created_at).format('MMM D, YYYY')}`}
            {questionStatus === Status.PUBLISHED
            && `Published ${moment(question.published_at).format('MMM D, YYYY')}`}
            {questionStatus === Status.ARCHIVED
            && `Archived ${moment(question.removed_at).format('MMM D, YYYY')}`}
          </span>
        )}
      </div>
      {!hasUpdated && (
        <div className="space-x-2">
          {canArchive && questionStatus !== Status.ARCHIVED && (
          <Button
            onClick={handleArchive}
            disabled={loading}
            buttonType={ButtonTypes.SECONDARY}
          >
            Archive
          </Button>
          )}
          {canPublish && questionStatus !== Status.PUBLISHED && (
          <Button
            onClick={handlePublish}
            disabled={loading}
            buttonType={ButtonTypes.SECONDARY}
          >
            Publish
          </Button>
          )}
        </div>
      )}
    </div>
  );
};

export default AdminControls;
